import React from 'react';
import GalaxyBackground from './components/GalaxyBackground';
import V2 from './pages/V2';
import './App.css';

// V2 (the iOS contact-card experience) is now the whole site.
function App() {
  return (
    <div className="App">
      <GalaxyBackground />
      <V2 />
    </div>
  );
}

export default App;
